{
	"selectPeriod": "Select a period",
	"periodSelected": "Period selected",
	"reset": "Reset",
	"apply": "Apply",
	"ariaLabels": {
		"periodSelection": "Select a period",
		"periodSelectionOptions": "Period selection options",
		"periodSelectionDialog": "Period selection",
		"dateRangeSelection": "Date range selection",
		"dateRangeSelectionActions": "Date range selection actions",
		"resetDateRange": "Reset date range selection",
		"applyDateRange": "Apply date range selection"
	}
}
